import { CurrencyPipe } from '@angular/common';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { CarteraService } from '../../../services/cartera/cartera.service';
import { ClienteService } from '../../../services/cliente/cliente.service';
import { ConfigService } from '../../../services/config/config.service';
import { VentaService } from '../../../services/venta/venta.service';
import { Router } from '@angular/router';
import { LocalizacionService } from '../../../services/localizacion/localizacion.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AutoComplete } from 'primeng/autocomplete';
import { ProveedorService } from '../../../services/proveedor/proveedor.service';
import { CatalogoService } from '../../../services/catalogo/catalogo.service';
import { supplierIntegrationService } from '../../../services/supplierIntegration/supplier-integration.service';
import { CotizacionService } from '../../../services/cotizacion/cotizacion.service';
import { NotifyService } from '../../../services/notify/notify.service';
import { EcommerceService } from '../../../services/ecommerce/ecommerce.service';


@Component({
  selector: 'app-ventas',
  templateUrl: './ventas.component.html',
  styleUrls: ['./ventas.component.scss'],
  standalone: false,
  providers: [MessageService, CurrencyPipe]
})
export class VentasComponent implements OnInit {
  load: boolean = false;
  loadMenu: boolean = false;
  resultsSKU: Array<any> = [];
  optTransaccion: number = 1;
  listBuy: Array<any> = [];
  listProducts: Array<any> = [];
  listProductsStore: Array<any> = [];
  listDptos: Array<any> = [];
  listCities: Array<any> = [];
  listIdentificationType: Array<any> = [];
  listStores: Array<any> = [];
  divStoreSelection: boolean = false;
  selectedStore: any = {};
  selectedSales: number = 0;
  itemSKU: any = {};
  metodoPagoIni: Array<any> = [];
  metodoPagoFilter: Array<any> = [];
  selectedMethod: any[] = [];
  vendedor: Array<any> = [];
  @ViewChild('autocomplete') autocomplete: AutoComplete | undefined;
  fieldSearch: any;
  subtotal: number = 0;
  impuesto: number = 0;
  valorRecaudo: number = 0;
  valorDevolucion: number = 0;
  valorFaltante: number = 0;
  valorDescuentoGeneral: number = 0;
  vlrCupoDisponible: number = 0;
  vlrCupoAsignado: number = 0;
  vlrCartera: number = 0;
  display: boolean = false;
  displayPrecio: boolean = false;
  displayDescuento: boolean = false;
  displaySummary: boolean = false;
  displayInfoClient: boolean = false;
  displayInfoECommerce: boolean = false;
  optNotificacion: number = 3;
  messageDiv: string = "";
  msgVenta: string = "";
  msgInicial: string = "";
  infoUser: any = {};
  infoEmpresa: any = {};
  infoCartera: any = {};
  token: any = {};
  idVenta: number = 0;
  registeredCustomer: boolean = false; // conocer si la venta fue registrada con cliente seleccionado
  idComprobante?: number;
  ventaforNC: any;

  bloqueo: boolean = false;
  infoParametrizacion: any = {};
  digito: number | undefined;
  @ViewChild('btnProcesar') btnProcesar: any;
  lsCotizacion: Array<any> = [];
  idSelectedQuotation: number | undefined;
  listPrices: Array<any> = [];
  priceDiscountType: number = 1;
  listOfBrancheOffice: Array<any> = [];
  selectedListPrices: number | undefined // personalizar la lista de precios al momento de la venta

  // canales de venta por donde se realiza la venta
  listCanalVenta: Array<any> = [];
  selectedListCanalVenta: any = {};

  // canales de procedencia
  listCanalIngreso: Array<any> = [];

  selectedCustomer?: any;
  formVenta = new FormGroup({
    tipo: new FormControl({ idTipoIdentificacion: 0 }, Validators.required),
    identificacion: new FormControl(null, [Validators.required, Validators.pattern(/^(0|[1-9][0-9]*)$/)]),
    razonSocial: new FormControl('', Validators.required),
    nombres: new FormControl('', [Validators.required, Validators.maxLength(200)]),
    direccion: new FormControl(''),
    departamento: new FormControl(null),
    ciudad: new FormControl(null),
    correo: new FormControl('', [Validators.email, Validators.required]),
    telefono: new FormControl('', [Validators.pattern(/^(0|[1-9][0-9]*)$/)]),
    selectedChannelIngreso: new FormControl(null, this.listCanalIngreso.length > 0 ? Validators.required : null),
    sucursal: new FormControl(null)
  });
  citySelected: any = {};
  clientIsNew: boolean = true;
  divInfoADD: boolean = true;

  //custom order number
  customOrdPrefijo: string = "";
  customOrdNumber: string = "";

  // Integracion con sistemas externos
  infoTercero: any = {};
  displayInfoTercero: boolean = false;

  // filtro de clientes
  resultsLsClients: Array<any> = [];
  fieldSearchClient: any | undefined;
  selectedClient: any | undefined;
  lockedFieldsIdClient: boolean = false;
  timeSearchCliente: any | undefined;

  // e-commerce
  nroSalesECommerce: number | undefined;
  salesECommerce: Array<any> = [];
  totales: any = { subtotal: 0, taxes: 0, shippingCost: 0 };

  constructor(private message: MessageService,
    private currency: CurrencyPipe,
    private venta: VentaService,
    private cliente: ClienteService,
    private config: ConfigService,
    private cartera: CarteraService,
    private router: Router,
    private localizacion: LocalizacionService,
    private proveedor: ProveedorService,
    private catalogo: CatalogoService,
    private integrationSupplier: supplierIntegrationService,
    private cotizacion: CotizacionService,
    private client: ClienteService,
    private ecommerce: EcommerceService
    //private notify:NotifyService
  ) { }

  ngOnInit(): void {
    this.token = JSON.parse(localStorage.getItem('token') ?? "".toString());
    this.listProducts = JSON.parse(localStorage.getItem("listProducts") ?? "[]") as Array<any>;
    this.listProductsStore = JSON.parse(localStorage.getItem("listProductsStore") ?? "[]") as Array<any>;
    this.metodoPagoIni = JSON.parse(localStorage.getItem("metodoPago") ?? "[]") as Array<any>;
    this.listPrices = JSON.parse(localStorage.getItem("listPrices") ?? "[]") as Array<any>;
    this.metodoPagoIni = this.metodoPagoIni.map(item => {
      return {
        "idVentaMetodoPago": item.idVentaMetodoPago,
        "label": item.metodoPago.toUpperCase(),
        "valor": 0,
        "referencia": item.idVentaMetodoPago == 1 ? "Efectivo" : ""
      }
    });
    this.vendedor = JSON.parse(localStorage.getItem("vendedor") ?? "[]") as Array<any>;
    this.infoParametrizacion = JSON.parse(localStorage.getItem('parametros') ?? "");

    console.log('parametrización', this.infoParametrizacion);
    // get stores information
    this.listStores = JSON.parse(localStorage.getItem('tiendas') ?? "[]");
    // solo se deja las tiendas que estan habilitadas para venta
    this.listStores = this.listStores.filter((row) => { return (row.forSale ?? true) == true });

    // get information of dptos
    this.listDptos = JSON.parse(localStorage.getItem('listDptos') ?? "[]");
    this.infoUser = JSON.parse(localStorage.getItem('infoUser') ?? "[]");
    this.infoEmpresa = JSON.parse(localStorage.getItem('empresa') ?? "[]");


    if (!localStorage.getItem('identificationType'))
      // get identification types
      this.cliente.getTypeIndetification(this.token.token).subscribe({
        next: (response) => {
          this.listIdentificationType = response as Array<any>;
          // asignación de variable global
          if (this.listIdentificationType.length > 0)
            localStorage.setItem('identificationType', JSON.stringify(this.listIdentificationType))
        },
        error: (error: HttpErrorResponse) => { this.config.handleError(error); }
      });
    else
      this.listIdentificationType = JSON.parse(localStorage.getItem('identificationType') ?? "[]")



    // definiendo por defecto el metodo de pago
    this.selectedMethod.push(this.metodoPagoIni[0]);

    //saber si esta vinculado a una tienda
    if ((!this.infoEmpresa[0].tiendaEmpleados[0])) {
      if ((this.infoUser.idPerfil == 5)) {
        // en caso de no estar vinculado debe elegir la tienda o la ubicación
        this.bloqueo = true;
        this.msgInicial = '<div class="p-message p-message-info">No esta vinculado a una tienda, favor contactar a su administrador</div>';
      } else {
        // exigir la selección de una ubicación
        this.divStoreSelection = true;
      }

    } else
      this.selectedStore = this.infoEmpresa[0].tiendaEmpleados[0].idTiendaNavigation;;


    // recordar seleccionar vendedores
    if (this.vendedor.length == 0) {
      // aplica para el perfil de cajero
      if (this.infoUser.idPerfil == 5) {
        this.bloqueo = true;
        this.msgInicial += '<div class="p-message p-message-info">Favor relacione los vendedores disponibles</div>';
      }
      else {
        // aplica para otro perfil
        this.proveedor.getVendedoresActivos(this.token.token, 4).subscribe({
          next: (response) => {
            let array: any = response as Array<any>;
            this.vendedor = array.map((item: any) => {
              return {
                id: item.idEmpleadoProveedor,
                label: item.idEmpleadoNavigation.nombres + " " + item.idEmpleadoNavigation.apellidos
              }
            });
            if (this.vendedor.length == 1)
              this.selectedSales = this.vendedor[0].id;
          },
          error: (error: HttpErrorResponse) => { this.config.handleError(error); }
        });
      }
    }
    else if (this.vendedor.length == 1)
      this.selectedSales = this.vendedor[0].id;

    //llevando al inicio
    setTimeout((content: any) => {
      this.config.navegar('divIni', false, -50)
    }, 1000)

    // get possible client entry channel
    if (!localStorage.getItem("channelClient")) {
      this.client.getPossibleEntryChannel(this.token.token).subscribe({
        next: (response) => {
          this.listCanalIngreso = response as Array<any>;
          localStorage.setItem("channelClient", JSON.stringify(this.listCanalIngreso));
        },
        error: (error: HttpErrorResponse) => { this.config.handleError(error); }
      });
    } else
      this.listCanalIngreso = JSON.parse(localStorage.getItem("channelClient") ?? "[]");

    // validar si existe canal de venta
    // get possible client entry channel
    if (!localStorage.getItem("channelSales")) {
      this.venta.getChannelSales(this.token.token).subscribe({
        next: (response) => {
          this.listCanalVenta = response as Array<any>;
          localStorage.setItem("channelSales", JSON.stringify(this.listCanalVenta));
          if (this.listCanalVenta.length == 1)
            this.selectedListCanalVenta = this.listCanalVenta[0];
        },
        error: (error: HttpErrorResponse) => { this.config.handleError(error); }
      });
    } else {
      this.listCanalVenta = JSON.parse(localStorage.getItem("channelSales") ?? "[]");
      if (this.listCanalVenta.length == 1)
        this.selectedListCanalVenta = this.listCanalVenta[0];
    }

  }

  reload() {
    window.location.reload();
  }

  redirigir = () => {
    this.router.navigate(['auth']);
  }

  clearFormCliente = (withType?: boolean) => {
    // solo se limpian los campos identificador del cliente cuando se requiera
    if (withType ?? false) {
      this.formVenta.controls.tipo.setValue(null);
      this.formVenta.controls.identificacion.setValue(null);
      this.lockedFieldsIdClient = false;
    }
    this.formVenta.controls.nombres.setValue('');
    this.formVenta.controls.direccion.setValue('');
    this.formVenta.controls.correo.setValue('');
    this.formVenta.controls.telefono.setValue('');
    this.formVenta.controls.razonSocial.setValue('');
    this.formVenta.controls.departamento.setValue(null)
    this.formVenta.controls.ciudad.setValue(null)
    this.digito = undefined;
    this.citySelected = {};
    this.lsCotizacion = [];
  }

  // obetener el cupo asignado por cliente
  getCupoClient = () => {
    this.displayInfoClient = false;
    // validando si el cliente dispone de cupo
    if (!!this.selectedClient) {
      if (this.formVenta.controls.identificacion.value != '') {
        this.cartera.getCartera(this.token.token, parseInt(this.formVenta.controls.identificacion.value ?? "0"), this.infoEmpresa[0].idProveedor).subscribe((response: any) => {
          if ((response as Array<any>).length > 0) {
            this.infoCartera = response[0];
            this.vlrCupoAsignado = response[0].valorAsignado;
            this.vlrCupoDisponible = response[0].valorAsignado - (response[0].valorPendiente ?? 0);
            this.vlrCartera = response[0].valorPendiente ?? 0;
          }
          else {
            this.infoCartera = response;
            this.vlrCupoAsignado = 0;
            this.vlrCupoDisponible = 0;
            this.vlrCartera = 0;
          }
        });
        this.selectedCustomer = this.formVenta;
      }
    }

  }

  // obtener las cotizaciones realizadas para proceder con el pago
  getQuotationCustomer = () => {
    if (this.formVenta.controls.identificacion.value != '')
      this.cotizacion.getCotizacionesInProcessCustomer(this.token.token, parseInt(this.formVenta.controls.identificacion.value ?? "")).subscribe({
        next: (response) => {
          this.lsCotizacion = response as Array<any>;
          this.lsCotizacion.map((row: any) => {
            // validar si se envio al cliente 
            row.detalleCotizacions.map((item: any) => {
              row.subtotal = ((row.subtotal ?? 0) + item.subtotal);
              row.impuesto = ((row.impuesto ?? 0) + item.impuesto);
            })
          })
        },
        error: (error: HttpErrorResponse) => { this.config.handleError(error); }
      })
  }

  // importar detalle de la cotización para convertirla en orden
  setDetailQuotation = (row: any) => {
    this.idSelectedQuotation = row.idCotizacion;
    row.detalleCotizacions.map((item: any) => {
      // adicionar los items
      let resultsSKU = this.listProducts.filter(prod => {
        return prod.idProducto == item.idProducto
      });

      this.onSetSku(resultsSKU[0], item.cantidad,
        (item.subtotal + item.impuesto) / item.cantidad,
        (item.subtotal + item.impuesto) / item.cantidad);
    })

  }

  searchItemClient = (string: any) => {
    window.clearTimeout(this.timeSearchCliente);
    this.timeSearchCliente = setTimeout(() => {
      this.client.getProspectiveClients(this.token.token, string.query).subscribe({
        next: (response) => {
          this.resultsLsClients = response as Array<any>;
          if (this.resultsLsClients.length == 0) {
            //this.autocomplete?.hide();
            // asignación de valores si no existe
            if (isNaN(parseInt(string.query))) {
              this.formVenta.controls.nombres.setValue(string.query);
              this.formVenta.controls.identificacion.reset()
            }
            else {
              this.formVenta.controls.identificacion.setValue(string.query);
              this.formVenta.controls.nombres.reset();
            }
          }
        },
        error: (error: HttpErrorResponse) => { this.config.handleError(error); }
      })
      window.clearTimeout(this.timeSearchCliente);
    }, 1000);


  }

  // una vez seleccionado se importa la información para mostrar en pantalla
  searchItemViewClient = (row: any) => {
    this.resultsLsClients = [];
    this.load = true;

    this.client.getClients(this.token.token, (row.value?.tipoIdentificacion ?? 1), row.value.identificacion).subscribe({
      next: (response) => {
        let client = (response as Array<any>);
        if (client.length > 0)
          this.selectedClient = client[0];

        this.load = false;
        if (client.length > 0) {
          // fill form
          this.lockedFieldsIdClient = true;
          this.clientIsNew = false;
          let typeIndetification: any = this.listIdentificationType.filter(row => row?.idTipoIdentificacion == this.selectedClient.idTipoIdentificacion)[0];
          this.formVenta.controls.tipo.setValue(typeIndetification);
          this.formVenta.controls.identificacion.setValue(this.selectedClient.identificacion);
          // verification digit calculation
          this.digito = this.config.getDigitVerification(this.selectedClient.identificacion.toString());

          this.formVenta.controls.razonSocial.setValue(this.selectedClient.razonSocial);
          this.formVenta.controls.nombres.setValue(this.selectedClient.nombres);
          this.formVenta.controls.correo.setValue(this.selectedClient.email);
          this.formVenta.controls.direccion.setValue(this.selectedClient.direccion);
          this.formVenta.controls.telefono.setValue(this.selectedClient.telefono);
          // load branche office of client
          this.listOfBrancheOffice = (this.selectedClient?.clienteSucursals ?? []).filter((row: any) => { return row.activo == true });

          // to assign branche_ office
          if (this.listOfBrancheOffice.length == 1)
            this.formVenta.controls.sucursal.setValue(this.listOfBrancheOffice[0]);


          // get city and depto
          if (!!this.selectedClient.idCiudad)
            this.localizacion.getCitiesId(this.token.token, this.selectedClient.idCiudad).subscribe({
              next: (response1) => {
                this.citySelected = response1;
                this.formVenta.controls.departamento.setValue((response1 as any).idDepartamentoNavigation);
                this.loadCities();
              },
              error: (error: HttpErrorResponse) => { this.config.handleError(error); }
            });

          // conocer la lista de precios a aplicar en caso de aplicar en tabla cliente procedencia, en caso de null se aplica lista de precios general
          if ((this.selectedClient?.clienteProcedencia ?? "[]").length > 0) {
            let procedencia = this.listCanalIngreso.filter((item: any) => { return item.idProcedencia == this.selectedClient?.clienteProcedencia[0].idProcedencia })[0];
            this.formVenta.controls.selectedChannelIngreso.setValue(procedencia);
            // validación de lsita de precios
            if ((this.selectedClient?.clienteProcedencia[0].idListaPrecios ?? 0) > 0)
              this.selectedListPrices = this.selectedClient?.clienteProcedencia[0]?.idListaPrecios;
          }
          // cambiar los precios en caso de tener ya detalle
          this.setPricesDetailSale()
        }
      },
      error: (error: HttpErrorResponse) => { this.config.handleError(error); }
    })
  }

  searchClient() {
    // si el registro es nuevo no se bloquea
    if (this.lockedFieldsIdClient == false)
      this.clearFormCliente(false);
    if (((this.formVenta.controls.identificacion.value ?? "") != '') && ((this.formVenta.controls.tipo.value?.idTipoIdentificacion ?? 0) > 0)) {

      // verification digit calculation
      this.digito = this.config.getDigitVerification(this.formVenta.controls.identificacion.value ?? "");

      this.cliente.getClients(this.token.token, this.formVenta.controls.tipo.value?.idTipoIdentificacion ?? 1,
        this.formVenta.controls.identificacion.value ?? "").subscribe((response) => {
          let client = response as Array<any>;
          if (client.length > 0)
            this.selectedClient = client[0];

          if (client.length > 0) {
            this.clientIsNew = false;
            this.formVenta.controls.nombres.setValue(this.selectedClient?.nombres);
            this.formVenta.controls.telefono.setValue(this.selectedClient?.telefono);
            this.formVenta.controls.correo.setValue(this.selectedClient?.email);
            this.formVenta.controls.direccion.setValue(this.selectedClient?.direccion);
            this.formVenta.controls.razonSocial.setValue(this.selectedClient?.razonSocial ?? 'N/A');
            // load branche office of client
            this.listOfBrancheOffice = (this.selectedClient?.clienteSucursals ?? []).filter((row: any) => { return row.activo == true });

            // to assign branche_ office
            if (this.listOfBrancheOffice.length == 1)
              this.formVenta.controls.sucursal.setValue(this.listOfBrancheOffice[0]);

            // get city and depto
            if (!!this.selectedClient?.idCiudad)
              this.localizacion.getCitiesId(this.token.token, this.selectedClient?.idCiudad).subscribe({
                next: (response1) => {
                  this.citySelected = response1;
                  this.formVenta.controls.departamento.setValue((response1 as any).idDepartamentoNavigation);
                  this.loadCities();
                },
                error: (error: HttpErrorResponse) => { this.config.handleError(error); }
              })

            // conocer la lista de precios a aplicar en caso de aplicar en tabla cliente procedencia, en caso de null se aplica lista de precios general
            if ((this.selectedClient?.clienteProcedencia ?? "[]").length > 0) {
              let procedencia = this.listCanalIngreso.filter((item: any) => { return item.idProcedencia == this.selectedClient?.clienteProcedencia[0].idProcedencia })[0];
              this.formVenta.controls.selectedChannelIngreso.setValue(procedencia);
              // validación de lsita de precios
              if ((this.selectedClient?.clienteProcedencia[0].idListaPrecios ?? 0) > 0)
                this.selectedListPrices = this.selectedClient?.clienteProcedencia[0]?.idListaPrecios;
            }
            // cambiar los precios en caso de tener ya detalle
            this.setPricesDetailSale()
          }
          else {
            this.searchClientExternSystem();
            this.clientIsNew = true;
          }
        });
    }
  }

  /// actualizar informción del cliente según selección
  setInfoClient = () => {
    // si es persona natural
    if (this.formVenta.value.tipo?.idTipoIdentificacion != 3)
      this.formVenta.controls.razonSocial.setValue('NA');



    if (this.formVenta.valid) {
      let idCity: any = this.formVenta.controls.ciudad.value ?? '{}';
      let selectedChannelClient: any = this.formVenta.controls.selectedChannelIngreso.value;

      // validación de la procedencia del cliente en caso ed tener parametrizado esta opción
      if ((this.listCanalIngreso.length > 0)) {
        if (((selectedChannelClient?.idProcedencia ?? 0) == 0)) {
          this.message.add({ severity: 'warn', detail: 'Favor elija la procedencia del cliente' });
          return;
        }
      }

      const data = {
        "idCliente": this.selectedClient?.idCliente ?? -1,
        "idTipoIdentificacion": this.formVenta.controls.tipo.value?.idTipoIdentificacion ?? 1,
        "digito": this.digito,
        "identificacion": this.formVenta.controls.identificacion.value,
        "razonSocial": this.formVenta.controls.razonSocial.value ?? '',
        "nombres": this.formVenta.controls.nombres.value,
        "direccion": this.formVenta.controls.direccion.value ?? '',
        "telefono": this.formVenta.controls.telefono.value ?? '',
        "email": this.formVenta.controls.correo.value,
        "idCiudad": !idCity.idCiudad ? null : idCity.idCiudad,
        "clienteProcedencia": (selectedChannelClient?.idProcedencia ?? 0) > 0 ? [{
          idCliente: this.selectedClient?.idCliente ?? 0,
          idProcedencia: selectedChannelClient?.idProcedencia,
          fecha: new Date()
        }] : null,
        "clienteSucursals": [
          {
            "idClienteSucursal": (this.formVenta.controls.sucursal.value as any)?.idClienteSucursal ?? 0,
            "idCliente": this.selectedClient?.idCliente ?? 0,
            "sucursal": (this.formVenta.controls.sucursal.value as any)?.sucursal ?? 0,
            "activo": true,
          }
        ]
      }

      this.cliente.setClient(this.token.token, data).subscribe((response) => {
        this.selectedClient = response as object;
        this.message.add({ severity: 'success', detail: 'Selección de cliente satisfactoria' });
      });

      this.selectedCustomer = this.formVenta;
      this.getQuotationCustomer();
      this.getCupoClient();
    }
    else
      this.message.add({ severity: 'warn', summary: 'Información', detail: 'Favor relacione la información del cliente, revise que la información relacionada este completa en los campos obligatorios' });
  }


  // funcion encargada de slección de tienda cuando aplique para la carga de productos
  eventSelectedStore = () => {
    if (!!this.selectedStore?.nombreTienda)
      this.divStoreSelection = false;
    if (!localStorage.getItem("listProducts")) {
      this.catalogo.getProductos(this.token.token, this.selectedStore.idTienda).subscribe(
        {
          next: (response) => {
            this.listProducts = response as Array<any>;
            localStorage.setItem("listProducts", JSON.stringify(this.listProducts));
          },
          error: (error: HttpErrorResponse) => {
            this.config.handleError(error);
          }
        });
    }
    else {
      this.listProducts = JSON.parse(localStorage.getItem("listProducts") ?? "[]");
    }
  }

  // funcion encargada de recalcular los precios
  setPricesDetailSale = () => {
    if (!!this.selectedListPrices && this.listBuy.length > 0) {
      this.listBuy.map((row: any) => {
        let listPriceSKU = row.detalleListaPrecios.filter((item: any) => { return item.idListaPrecios == this.selectedListPrices });
        if (listPriceSKU.length > 0)
          row.precioProducto.precio = listPriceSKU[0].precio;
        row.precioProducto.precioPromocion = listPriceSKU[0].precioPromocion;
      });
      this.getTotal();
    }
  }

  searchItem(event: any) {
    this.resultsSKU = this.listProducts.filter(item => {
      event.query = this.replaceCharacter(event.query);
      return item.descripcionCorta.toLowerCase().indexOf(event.query.toLowerCase()) > -1 || item.codBarras.toLowerCase().indexOf(event.query.toLowerCase()) > -1 || item.referencia.toLowerCase().indexOf(event.query) > -1
    });
    // saber si hay algun producto en caso de ser asi se hace el procedimiento de selección
    // una vez pase 2 segundos
    if (this.resultsSKU.length == 1) {
      setTimeout(() => {
        // adición de SKU
        if (this.resultsSKU.length == 1)
          this.onSetSku(this.resultsSKU[0], 1);
      }, 300);
    }
  }

  searchItemView(event: any) {
    // ocurre cuando selecciono un campo
    if (typeof event == 'object') {
      this.onSetSku(event.value, 1);
    }
  }

  // por defecto muestra la lista de precios asignada para el cliente 
  onSetSku(row: any, cantidad: number, precioFinal?: number, precioPromocion?: number) {

    // establecer los nombres de las posibles lista de precios
    row.detalleListaPrecios.map((item: any) => {
      item.nameListPrices = this.listPrices.filter((field: any) => field.idListaPrecios == item.idListaPrecios)[0].nombreListaPrecios
    })
    /// en caso de haber seleccionado el cliente, modificar el precio standar por el de la lista asignada
    if (!!this.selectedListPrices) {
      let pricesNew = row.detalleListaPrecios.filter((item: any) => { return item.idListaPrecios == this.selectedListPrices })[0];
      if (!!pricesNew) {
        // campos a modificar siempre y cuando se obtenga datos
        row.precioProducto.precio = pricesNew.precio;
        row.precioProducto.precioPromocion = pricesNew.precioPromocion;
      }
    }

    // validate of images 
    if (row.productoImagenes.length > 0) {
      row.productoImagenes.sort((a: any, b: any) => {
        return parseFloat(a.order) - parseFloat(b.order)
      });

      row.image = {
        itemImageSrc: this.config.urlIMG + row.productoImagenes[0].ubicacion,
        thumbnailImageSrc: this.config.urlIMG + row.productoImagenes[0].ubicacion,
        alt: row.descripcionCorta,
        title: row.descripcionCorta,
        order: row.orden
      }
    }

    //if (!row.inventory)
    // Validate Inventory
    this.catalogo.getProductoInventarioTienda(this.token.token, this.selectedStore.idTienda, row.idProducto).subscribe({
      next: (response) => {
        let data: any = response as any;
        row.inventory = data.cantidad;

        //******************************************************* Asign inventory and prices************************************* */
        // se realiza para eliminar la memoria referencia
        let dataRow = JSON.parse(JSON.stringify(row));

        console.log(dataRow);

        // Se carga el precio y se respeta si viene discriminado
        if (!!precioFinal) {
          dataRow.precioProducto.precio = precioFinal;
          dataRow.precioProducto.precioPromocion = precioPromocion;
        }

        // validar si ya existe
        let index = this.listBuy.findIndex((item) => {
          return (item.idProducto == row.idProducto)
        });

        if (index > -1) {
          this.listBuy[index].cantidad = this.listBuy[index].cantidad + cantidad;
        }
        else {
          // modificar la ruta para que pueda visualizar la imagen
          if (row.productoImagenes.length > 0)
            dataRow.productoImagenes[0].ubicacion = this.config.urlService + "Resources/Imagenes/" + row.productoImagenes[0].ubicacion;
          dataRow.cantidad = cantidad;

          // si la tienda es exenta no debe calcular el IVA y mostrar el precio unitario sin Impuestos
          if (this.selectedStore.exentoIva) {
            dataRow.impuesto = 0;
            dataRow.precioProducto.preciosinIMPTO = dataRow.precioProducto.precio;
            dataRow.precioProducto.preciosinIMPTOPromo = dataRow.precioProducto.precioPromocion;
          } else {
            dataRow.precioProducto.preciosinIMPTO = Number(((dataRow.precioProducto.precio / ((dataRow.impuesto / 100) + 1)) * dataRow.cantidad).toFixed(2));
            dataRow.precioProducto.preciosinIMPTOPromo = Number(((dataRow.precioProducto.precioPromocion / ((dataRow.impuesto / 100) + 1)) * dataRow.cantidad).toFixed(2));
          }

          this.listBuy.push(dataRow);

          let item: string = 'item' + (this.listBuy.length - 1).toString();
          /* setTimeout((content: any) => {
            this.navegar(item, false, -30)
          }, 1000) */

        }
        // proceda a la limpieza
        this.fieldSearch = null;
        this.autocomplete?.hide();
        this.resultsSKU = [];
        this.getTotal();
        //**************************************************************************************************************** */
      },
      error: (error: HttpErrorResponse) => { console.error(error) }
    });


  }

  cambioPrecio(index: number) {
    this.itemSKU = this.listBuy[index];
    this.itemSKU.index = index;
    this.displayPrecio = true;
  }

  setCambioPrecio() {
    if (this.itemSKU.precioFinal > 0) {

      // si el precio es mayor al asignado se procede con la actualización en el precio general
      if (this.listBuy[this.itemSKU.index].precioProducto.precio < this.itemSKU.precioFinal)
        this.listBuy[this.itemSKU.index].precioProducto.precio = this.itemSKU.precioFinal;

      this.listBuy[this.itemSKU.index].precioProducto.precioPromocionOld = this.listBuy[this.itemSKU.index].precioProducto.precioPromocion;
      this.listBuy[this.itemSKU.index].precioProducto.precioPromocion = this.priceDiscountType == 1 ? this.itemSKU.precioFinal : (this.listBuy[this.itemSKU.index].precioProducto.precioPromocion - (this.itemSKU.precioFinal * this.listBuy[this.itemSKU.index].precioProducto.precioPromocion) / 100);


      // si la tienda es exenta no debe calcular el IVA y se cambia el precio unitario al modificar el precio en promocion
      if (this.selectedStore.exentoIva) {
        // si el precio es mayor al asignado se procede con la actualización en el precio general
        if (this.listBuy[this.itemSKU.index].precioProducto.preciosinIMPTO < this.itemSKU.precioFinal)
          this.listBuy[this.itemSKU.index].precioProducto.preciosinIMPTO = this.listBuy[this.itemSKU.index].precioProducto.precioPromocion
        this.listBuy[this.itemSKU.index].precioProducto.preciosinIMPTOPromo = this.listBuy[this.itemSKU.index].precioProducto.precioPromocion;
      } else {
        // si el precio es mayor al asignado se procede con la actualización en el precio general
        if (this.listBuy[this.itemSKU.index].precioProducto.preciosinIMPTO < this.itemSKU.precioFinal)
          this.listBuy[this.itemSKU.index].precioProducto.preciosinIMPTO = this.listBuy[this.itemSKU.index].precioProducto.precioPromocion
        this.listBuy[this.itemSKU.index].precioProducto.preciosinIMPTOPromo = Number(((this.listBuy[this.itemSKU.index].precioProducto.precioPromocion / ((this.listBuy[this.itemSKU.index].impuesto / 100) + 1)) * this.listBuy[this.itemSKU.index].cantidad).toFixed(2));

      }

      this.displayPrecio = false;
      this.getTotal()
      this.message.add({ severity: 'success', summary: 'Información', detail: 'Se aplico el precio' + this.currency.transform(this.itemSKU.precioFinal) });
    }
    else
      this.message.add({ severity: 'warn', summary: 'Información', detail: 'El producto no puede registrar en precio cero' });
  }


  descuentoGeneral = () => {
    this.displayDescuento = true;
  }

  setDescuentoGeneral = () => {
    if (this.valorDescuentoGeneral > 0) {
      this.listBuy.map((row: any) => {
        if (!row?.precioProducto.hasOwnProperty('precioPromocionOld'))
          row.precioProducto.precioPromocionOld = row.precioProducto.precioPromocion;
        row.precioProducto.precioPromocion = row.precioProducto.precioPromocionOld - (row.precioProducto.precioPromocion * (this.valorDescuentoGeneral / 100))
      });
      this.getTotal();
      this.displayDescuento = false;
      this.valorDescuentoGeneral = 0;
      this.message.add({ severity: 'success', summary: 'Información', detail: 'Se aplico el ' + this.valorDescuentoGeneral + '% a todos los productos' });
    }
  }

  setResetDiscount = () => {
    this.listBuy.map((row: any) => {
      if (!!row?.precioProducto.hasOwnProperty('precioPromocionOld'))
        row.precioProducto.precioPromocion = row.precioProducto.precioPromocionOld;
    });
    this.getTotal();
    this.message.add({ severity: 'success', summary: 'Información', detail: 'Se restauro el precio a todos los productos de la compra' });
  }
  // tipo se maneja para distinguir las nota credito o devoluciones
  getTotal() {
    this.subtotal = 0;
    this.impuesto = 0;
    // en caso de encontrar una cantidad en 0
    let position = this.listBuy.findIndex((item: any) => {
      return item.cantidad == 0
    });
    if (position > -1)
      this.listBuy.splice(position, 1);

    this.listBuy.map((item) => {
      this.subtotal += Number((((item.precioProducto.precioPromocion >
        item.precioProducto.precio ? item.precioProducto.precio : item.precioProducto.precioPromocion) / ((item.impuesto / 100) + 1)) * item.cantidad).toFixed(2));
      this.impuesto += Number(((item.precioProducto.precioPromocion >
        item.precioProducto.precio ? item.precioProducto.precio : item.precioProducto.precioPromocion) * item.cantidad).toFixed(2)) -
        // subtotal
        Number((((item.precioProducto.precioPromocion >
          item.precioProducto.precio ? item.precioProducto.precio : item.precioProducto.precioPromocion) / ((item.impuesto / 100) + 1)) * item.cantidad).toFixed(2));

    });
    // reviar el tema de valor faltante
    this.getFaltante(null, '');
  }


  filterMetodo(event: any) {
    this.valorRecaudo = 0;
    this.getFaltante(null, '');
    // el idMetodoPago = 10 hace referencia a la cartera propia
    this.metodoPagoFilter = this.metodoPagoIni.filter((row: any) => {
      if (row.label.toLowerCase().indexOf(event.query) > -1) {
        if (row.idVentaMetodoPago == 10 && this.vlrCupoDisponible <= 0)
          return;
        else if (row.idVentaMetodoPago == 15)
          row.referencia = 'Credito propio';
        return row;
      }

    });
  }


  toSeeSummary = () => {
    this.displaySummary = true;
  }

  getDetalleVenta() {
    // falta obtener proveedor
    this.venta.getDetalleVenta(this.token.token, this.idComprobante ?? 0, this.infoEmpresa[0].idProveedor).subscribe({
      next: (response) => {
        //Información para obtener fecha y persona que realizo el registro
        this.ventaforNC = response as Array<any>;
        if (this.ventaforNC.idVentaEstado == 3) {
          let resp: any = this.ventaforNC.detalleVenta as Array<any>;
          this.valorDevolucion = this.ventaforNC.subtotal + this.ventaforNC.impuesto;
          this.listBuy = resp.map((row: any) => {
            if (row.idProductoNavigation.productoImagenes.length > 0)
              row.idProductoNavigation.productoImagenes.map((item: any) => {
                item.ubicacion = this.config.urlService + 'Resources/Imagenes/' + item.ubicacion
              })

            return {
              idProducto: row.idProductoNavigation.idProducto,
              descripcionCorta: row.idProductoNavigation.descripcionCorta,
              referencia: row.idProductoNavigation.referencia,
              unidadPresentacion: row.idProductoNavigation.unidadPresentacion,
              marca: row.idProductoNavigation.marca,
              cantidad: row.cantidad,
              impuesto: row.idProductoNavigation.impuesto,
              precioProducto: {
                precioPromocion: (row.subtotal + row.impuesto) / row.cantidad,
                precio: (row.subtotal + row.impuesto) / row.cantidad
              },
              productoImagenes: row.idProductoNavigation.productoImagenes
            };
          });
          // validar las cantidades 
          // obtener el detalle si ha registrado notas credito antes
          this.venta.getDetalleNotaCredito(this.token.token, this.idComprobante ?? 0).subscribe({
            next: (resp) => {
              let arrayTemp: any = resp as Array<any>;
              this.listBuy.forEach((row: any, index: number) => {
                var rowNota = arrayTemp.filter((item: any) => {
                  return item.idProducto == row.idProducto;
                });
                if (rowNota.length > 0) {
                  row.cantidad = row.cantidad - rowNota[0].cantidad;

                  if (row.cantidad <= 0)
                    this.listBuy.splice(index, 1);
                }
                this.getTotal();
              });
              if (this.listBuy.length == 0)
                this.message.add({ severity: 'warn', summary: 'Información', detail: 'Esta venta ya fue procesada en su totalidad' });

            }, error: (error: HttpErrorResponse) => {
              this.config.handleError(error);
            }
          });

        } else
          this.message.add({ severity: 'warn', summary: 'Información', detail: 'La venta relacionada no aplica para realizar notas crédito' });
      }, error: (error: HttpErrorResponse) => {
        this.message.add({ severity: 'warn', summary: 'Información', detail: 'No existe venta  bajo este número' });
      }
    });

  }

  getInfoMultiplePago = () => {
    let valorRecaudo: any = {
      valorRecaudo: 0,
      valorEfectivo: 0
    };
    return new Promise((resolve, reject) => {
      // **************** validar si tiene nota credito *************************
      let hasNota = this.selectedMethod.findIndex(row => {
        return row.idVentaMetodoPago == 4;
      });
      // en caso de tener se debe importar desde bd
      if (hasNota > -1) {
        if (!isNaN(parseInt(this.selectedMethod[hasNota].referencia.trim()))) {
          this.load = true;
          this.venta.getNotaCredito(this.token.token, this.selectedMethod[hasNota].referencia.trim(), this.infoEmpresa[0].idProveedor).subscribe((response) => {
            let notaCredito: any = response;
            if (!notaCredito) {
              this.message.add({ severity: 'error', summary: 'Error', detail: 'La nota credito relacionada no existe' });
            }
            else {
              if (notaCredito.notaCreditoIdVentaNotaNavigations[0].activo) {
                this.selectedMethod[hasNota].valor = notaCredito.subtotal + notaCredito.impuesto
                this.selectedMethod.forEach(row => {
                  if (row.idVentaMetodoPago == 1)
                    valorRecaudo.valorEfectivo = row.valor;
                  valorRecaudo.valorRecaudo += row.valor;
                });
              }
              else {
                this.message.add({ severity: 'error', summary: 'Error', detail: 'La nota credito ya fue utilizada' });
                valorRecaudo.valorRecaudo = 0;
              }
            }
            this.load = false;
            resolve(valorRecaudo);
          });
        } else
          this.message.add({ severity: 'error', summary: 'Error', detail: 'El id de la nota de credíto debe ser numerico' });
      }
      else {
        this.selectedMethod.forEach(row => {
          if (row.idVentaMetodoPago == 1)
            valorRecaudo.valorEfectivo = row.valor;
          valorRecaudo.valorRecaudo += row.valor;
        });
        resolve(valorRecaudo);
      }
      //********************************************************************** 
    });
  }


  /// Validaciones previas antes del resgitro de ventas
  procesarVenta() {
    var isValid: boolean = false;
    this.messageDiv = "";

    // hacer perder el foco
    this.btnProcesar.nativeElement.blur();


    // validate inventory
    let availableInventory: boolean = true;
    if (this.infoParametrizacion.recordInventorySales) {
      this.listBuy.map((row: any) => {
        if (row.inventory < row.cantidad) {
          row.error = '<div class="p-message p-message-warn">&#x261D; &nbsp; Revisar</div>';
          this.message.add({ severity: 'error', summary: 'Error', detail: 'Alguno de los items no tiene inventario', icon: "pi pi-check" });
          availableInventory = false;
        }
        else
          row.error = '';
      })
    }
    if (availableInventory) {
      // validar que el cliente este seleccionado si es 1 como factura elecónica obligatoria
      if (((this.selectedStore?.processTypeFe ?? 3) == 1) && (!this.selectedCustomer?.controls?.correo.valid)) {
        this.message.add({ severity: 'error', summary: 'Error', detail: 'Favor relacione el cliente y que registre el correo electrónico' });
      }
      else if (this.listCanalVenta.length > 0 && (!this.selectedListCanalVenta)) {
        this.message.add({ severity: 'error', summary: 'Error', detail: 'Favor relacione el canal de venta' });
      }
      else if (this.listOfBrancheOffice.length > 1 && ((this.formVenta.controls.sucursal as any).idClienteSucursal ?? 0) > 0) {
        this.message.add({ severity: 'error', summary: 'Error', detail: 'Favor relacione la sucursal' });
      }
      // validar si hay efectivo se puede dar vueltas
      // validar los valores
      else if (this.selectedMethod.length == 0)
        this.message.add({ severity: 'error', summary: 'Error', detail: 'Favor seleccione una forma de pago' });
      else
        if (this.selectedMethod.length > 1) {
          // validar que los campos cuente con referencia y valor, excepto la nota credito que solo se exige la referencia
          let campoRef = this.selectedMethod.filter(item => { return item.referencia == '' || item.valor == 0 })
          if (campoRef.length > 0)
            this.message.add({ severity: 'error', summary: 'Error', detail: 'Favor registre un valor y referencia del pago' });
          else {
            let hasEfectivo = this.selectedMethod.findIndex(item => { return item.idVentaMetodoPago == 1 });

            // obtener los valores para preparar el pago
            this.getInfoMultiplePago().then((valorRecaudo: any) => {
              // si no tiene efectivo el valor total debe ser igual al valor a cancelar
              if ((hasEfectivo == -1) && (valorRecaudo.valorRecaudo != Math.round(this.subtotal + this.impuesto))) {
                this.message.add({ severity: 'error', summary: 'Error', detail: 'El valor recaudado debe ser igual al valor total de la venta' });
              }

              else {

                if ((hasEfectivo > -1) && ((valorRecaudo.valorRecaudo) - (this.subtotal + this.impuesto) > 0)) {
                  // validar los valores para luego definir cuanto queda en efectivo
                  //revisar el total cancelado
                  this.selectedMethod[hasEfectivo].valor = (this.subtotal + this.impuesto) - (valorRecaudo.valorRecaudo - valorRecaudo.valorEfectivo);
                  this.messageDiv = `<div class='p-1 p-message p-message-success'><h4>Recuerde devolver al cliente : ${this.currency.transform(valorRecaudo.valorRecaudo - (this.subtotal + this.impuesto))}</h4></div>`;
                  isValid = true;
                }
                else if ((valorRecaudo.valorRecaudo - Math.round(this.subtotal + this.impuesto)) < 0) {
                  console.log(valorRecaudo.valorRecaudo, Math.round(this.subtotal + this.impuesto))
                  this.message.add({ severity: 'error', summary: 'Error', detail: 'El valor recaudado debe ser igual  o mayor al valor total de la venta' });
                }
                else
                  isValid = true;
              }

              if (isValid) {
                // validar el valor de la venta pues debe ser mayor a la nota credito
                let hasNota: any = this.selectedMethod.filter(row => {
                  return row.idVentaMetodoPago == 4;
                });
                if (hasNota.length > 0) {
                  isValid = false;
                  if (parseInt(hasNota[0].valor) < (this.subtotal + this.impuesto))
                    isValid = true;
                  else
                    this.message.add({ severity: 'warn', summary: 'Información', detail: 'El total de venta debe ser mayor al valor de la nota credito' });
                }
              }

              if (isValid) {
                // validar si el cupo del cliente es menor al valor de la venta
                let hasCupoClient = this.selectedMethod.filter(row => {
                  return row.idVentaMetodoPago == 10;
                });
                if (hasCupoClient.length > 0) {
                  isValid = false;
                  if (parseInt(hasCupoClient[0].valor) <= (this.vlrCupoDisponible))
                    isValid = true;
                  else
                    this.message.add({ severity: 'warn', summary: 'Información', detail: 'El valor relacionado no puede superar el cupo disponible' });
                }
              }
              // ******************* procesar venta ***************************+
              if (this.selectedSales > 0) {
                if (isValid)
                  this.setVenta();
              } else
                this.message.add({ severity: 'error', summary: 'Error', detail: 'Favor seleccione el vendedor' });
            })

          }
        }
        else {
          // solo una opción de pago
          if (this.selectedMethod.length == 1) {
            switch (this.selectedMethod[0].idVentaMetodoPago) {
              // conocer si es efectivo
              case 1:
                if (this.valorRecaudo >= (this.subtotal + this.impuesto)) {
                  let devolver: any = this.valorRecaudo - (this.subtotal + this.impuesto);
                  // actualizar valor a ingresar
                  this.selectedMethod[0].valor = (this.subtotal + this.impuesto);
                  if (devolver > 0)
                    this.messageDiv = `<div class='p-1 p-message p-message-success'><h4>Recuerda devolver al cliente : ${this.currency.transform(devolver)}</h4></div>`;
                  isValid = true;
                }
                else
                  // notificar error
                  this.message.add({ severity: 'error', summary: 'Error', detail: 'Favor relacione el valor recaudado, este debe ser igual o mayor al total de la venta' });

                // ******************* procesar venta ***************************+
                if (this.selectedSales > 0) {
                  if (isValid)
                    this.setVenta();
                } else
                  this.message.add({ severity: 'error', summary: 'Error', detail: 'Favor seleccione el vendedor' });
                //*******************************************************************
                break;
              // conocer si es nota credito
              case 4:
                // si es nota credito se valida el valor
                if (!isNaN(parseInt(this.selectedMethod[0].referencia.trim()))) {
                  this.load = true;
                  this.venta.getNotaCredito(this.token.token, this.selectedMethod[0].referencia.trim(), this.infoEmpresa[0].idProveedor).subscribe({
                    next: (response) => {
                      let notaCredito: any = response;
                      if (!notaCredito) {
                        this.message.add({ severity: 'error', summary: 'Error', detail: 'La nota credito relacionada no existe' });
                      }
                      if (!notaCredito.notaCreditoIdVentaNotaNavigations[0].activo)
                        this.message.add({ severity: 'error', summary: 'Error', detail: 'La nota credito ya fue utilizada' });
                      else if (((this.subtotal + this.impuesto) == (notaCredito.subtotal + notaCredito.impuesto))) {
                        this.selectedMethod[0].valor = notaCredito.subtotal + notaCredito.impuesto;
                        isValid = true;
                      }
                      else
                        this.message.add({
                          severity: 'error', summary: 'Error', detail: 'La nota credito debe ser igual al valor, la nota credito relacionada esta por valor de ' +
                            this.currency.transform((notaCredito.subtotal + notaCredito.impuesto)) + ' '
                        });
                      this.load = false;
                      // ******************* procesar venta ***************************+
                      if (this.selectedSales > 0) {
                        if (isValid)
                          this.setVenta();
                      } else
                        this.message.add({ severity: 'error', summary: 'Error', detail: 'Favor seleccione el vendedor' });
                      //*******************************************************************
                    }, error: (error: Response) => {
                      if (error.status == 404) {
                        this.message.add({ severity: 'error', summary: 'Error', detail: 'No se encontro ninguna nota crédito bajo la referencia relacionada' });
                        this.load = false;
                      }
                    }
                  });
                } else
                  this.message.add({ severity: 'error', summary: 'Error', detail: 'El id de la nota de credíto debe ser numerico' });
                break
              case 10:
                // cartera propia
                if ((this.subtotal + this.impuesto) > this.vlrCupoDisponible) {
                  this.message.add({ severity: 'error', summary: 'Error', detail: 'El valor de la venta no puede superar el cupo disponible' });
                  isValid = false;
                }
                else {
                  this.selectedMethod[0].valor = (this.subtotal + this.impuesto);
                  this.setVenta();
                }
                break;
              default:
                // validar si el campo tiene registrado la referencia
                this.selectedMethod[0].valor = (this.subtotal + this.impuesto);
                if (this.selectedMethod[0].referencia == '')
                  this.message.add({ severity: 'error', summary: 'Error', detail: 'Favor registre un valor referencia del pago' });
                else
                  isValid = true;
                // ******************* procesar venta ***************************+
                if (this.selectedSales > 0) {
                  if (isValid)
                    this.setVenta();
                } else
                  this.message.add({ severity: 'error', summary: 'Error', detail: 'Favor seleccione el vendedor' });
                //*******************************************************************
                break;
            }
          }
        }

    }
  }

  setVenta = () => {
    this.load = true;
    let dataBuy = this.listBuy.map((item) => {
      return {
        "idProducto": item.idProducto,
        "cantidad": item.cantidad,
        "subtotal": Number(((((item.precioProducto.precioPromocion < item.precioProducto.precio ? item.precioProducto.precioPromocion : item.precioProducto.precio)) / (((item.impuesto) / 100) + 1)) * item.cantidad).toFixed(2)),
        "impuesto": Number((((item.precioProducto.precioPromocion < item.precioProducto.precio ? item.precioProducto.precioPromocion : item.precioProducto.precio) * item.cantidad)).toFixed(2)) -
          //subtotal  
          Number(((((item.precioProducto.precioPromocion < item.precioProducto.precio ? item.precioProducto.precioPromocion : item.precioProducto.precio)) / (((item.impuesto) / 100) + 1)) * item.cantidad).toFixed(2)),
        "descuento": Number((((item.precioProducto.precio * item.cantidad) - (item.precioProducto.precioPromocion * item.cantidad)) / (((item.impuesto) / 100) + 1)).toFixed(2))
      }
    });

    const data = {
      "idEmpleadoProveedor": this.infoUser.empleadoProveedors[0].idEmpleadoProveedor,
      "idEmpleadoProveedorVenta": this.selectedSales,
      "idTienda": this.selectedStore.idTienda,
      // este valor 15  es el id cliente por defecto
      "idCliente": (this.selectedClient?.idCliente ?? 0) > 0 ? this.selectedClient?.idCliente : 15,
      "subtotal": this.subtotal,
      "impuesto": this.impuesto,
      "descuento": 0,
      "idVentaEstado": 3,
      "prefijoOC": this.customOrdPrefijo ?? "",
      "numberOC": this.customOrdNumber ?? "",
      "observacion": "Ninguna",
      "detalleVenta": dataBuy,
      "ventaPagos": this.selectedMethod,
      "idCanalVenta": this.selectedListCanalVenta.idCanalVenta ?? null,
      "idClienteSucursal": (this.formVenta.controls.sucursal.value ?? {} as any)?.idClienteSucursal ?? 0
    }

    // ******************  se procede a registrar la venta **********************
    console.log('REGISTRO DE VENTA');
    this.venta.setVenta(this.token.token, data,
      (this.selectedStore.processTypeFe ?? 3)
      , this.idSelectedQuotation).subscribe({
        next: (response) => {
          this.idVenta = parseInt(response.toString());
          // conocer si la venta ya se registro con cliente 
          // en caso de si no es posible personalizarlo en la segunda opción
          if ((this.selectedClient?.idCliente ?? 0) > 0)
            this.registeredCustomer = true;
          else
            this.registeredCustomer = false;

          this.load = false;
          this.display = true;
          // temporary data allocation
          this.formVenta.controls.identificacion.setValue(this.selectedCustomer.controls.identificacion.value);
          this.formVenta.controls.tipo.setValue(this.selectedCustomer.controls.tipo.value);
          this.formVenta.controls.nombres.setValue(this.selectedCustomer.controls.nombres.value);
          this.formVenta.controls.correo.setValue(this.selectedCustomer.controls.correo.value);
          this.formVenta.controls.razonSocial.setValue(this.selectedCustomer.controls.razonSocial.value);
          this.formVenta.controls.departamento.setValue(this.selectedCustomer.controls.departamento.value);
          this.formVenta.controls.ciudad.setValue(this.selectedCustomer.controls.ciudad.value);

          // Proceso de registro a Sistema de Facturación
          if ((this.selectedStore.processTypeFe ?? 3) == 1) {
            if (this.infoParametrizacion.integrationSystem == 'SIIGO')
              // solo aplica este para SIIGO
              this.setFacturaElectronicaSIIGO(this.idVenta);
          }


        }, error: (error: HttpErrorResponse) => {
          this.config.handleError(error);
          this.message.add({ severity: 'error', summary: 'Error', detail: 'Se ha presentado un error, favor intente nuevamente' });
        }
      });
    //***************************************************************************
  }

  procesarDevolucion() {
    if (this.valorDevolucion >= (this.subtotal + this.impuesto)) {
      let dataBuy = this.listBuy.map((item) => {
        return {
          "idProducto": item.idProducto,
          "cantidad": item.cantidad,
          "subtotal": Math.round(((((item.precioProducto.precioPromocion < item.precioProducto.precio ? item.precioProducto.precioPromocion : item.precioProducto.precio)) / (((item.impuesto) / 100) + 1)) * item.cantidad)),
          "impuesto": Math.round((((item.precioProducto.precioPromocion < item.precioProducto.precio ? item.precioProducto.precioPromocion : item.precioProducto.precio) * item.cantidad))) -
            //subtotal  
            Math.round(((((item.precioProducto.precioPromocion < item.precioProducto.precio ? item.precioProducto.precioPromocion : item.precioProducto.precio)) / (((item.impuesto) / 100) + 1)) * item.cantidad)),
          "descuento": (item.precioProducto.precio * item.cantidad) - (item.precioProducto.precioPromocion * item.cantidad)
        }
      });

      const data = {
        "idEmpleadoProveedor": this.infoUser.empleadoProveedors[0].idEmpleadoProveedor,
        "idEmpleadoProveedorVenta": 1, // id Empleado por defecto
        "idTienda": this.selectedStore.idTienda,
        //"idUser": 1,
        "subtotal": this.subtotal,
        "impuesto": this.impuesto,
        "descuento": 0,
        "idVentaEstado": 4,
        "observacion": "Nota credito",
        "detalleVenta": dataBuy
      };

      this.load = true;
      this.venta.setNotaCredito(this.token.token, data, this.idComprobante ?? 0).subscribe({
        next: (response) => {
          this.idVenta = parseInt(response.toString());
          this.load = false;
          this.display = true;
        }, error: (error: HttpErrorResponse) => {
          this.config.handleError(error);
          this.message.add({ severity: 'error', summary: 'Error', detail: 'Se ha presentado un error, favor intente nuevamente' });

        }
      });
    }
    else {
      this.message.add({ severity: 'error', summary: 'Error', detail: 'La nota credito a realizar no puede ser mayor al valor inicial' });
    }
  }


  //load cities
  loadCities = () => {
    this.localizacion.getCities(this.token.token, (this.formVenta.controls.departamento.value as any).idDepartamento).subscribe({
      next: (response) => {
        this.listCities = response as Array<any>;
        // there is a selected city
        if (this.citySelected?.idCiudad > 0)
          this.formVenta.controls.ciudad.setValue(this.listCities.filter(row => row.idCiudad == this.citySelected?.idCiudad)[0]);
      },
      error: (error: HttpErrorResponse) => { this.config.handleError(error); }
    })
  }

  /**
    * LLenar el formulario de venta del cliente con información de SIIGO
    */
  fillFormClientExternSystem = () => {
    if (!!localStorage.getItem('tokenSIIGO')) {
      if (this.infoTercero.results.length > 0) {
        this.formVenta.controls.tipo.setValue(this.listIdentificationType.filter(row => { return row.codProveedorDian1 == this.infoTercero.results[0].id_type.code.toString() })[0]);
        this.formVenta.controls.nombres.setValue(this.infoTercero.results[0].contacts[0].first_name + " " + this.infoTercero.results[0].contacts[0].last_name);
        this.formVenta.controls.telefono.setValue(this.infoTercero.results[0].phones[0].phone);
        this.formVenta.controls.correo.patchValue(this.infoTercero.results[0].contacts[0].email);
        this.formVenta.controls.direccion.setValue(this.infoTercero.results[0].address.address);
        this.formVenta.controls.razonSocial.setValue(this.infoTercero.results[0].name.join(' '));

        // sucursal
        if (this.listOfBrancheOffice.filter((item: any) => { return item.sucursal == this.infoTercero.results[0].branch_office }).length == 0)
          this.listOfBrancheOffice.push({ sucursal: this.infoTercero.results[0].branch_office });

        if (this.listOfBrancheOffice.length == 1)
          this.formVenta.controls.sucursal.setValue(this.listOfBrancheOffice[this.listOfBrancheOffice.length - 1]);

        //show dpto
        this.formVenta.controls.departamento.setValue(this.listDptos.filter(row => row.codDepartamento == this.infoTercero.results[0].address.city.state_code)[0]);
        // load cities and selected
        this.localizacion.getCities(this.token.token, (this.formVenta.controls.departamento.value as any).idDepartamento).subscribe({
          next: (response) => {
            this.listCities = response as Array<any>;
            // there is a selected city
            this.formVenta.controls.ciudad.setValue(this.listCities.filter(row => row.codCiudad == this.infoTercero.results[0].address.city.city_code)[0]);

            this.displayInfoTercero = false;
          },
          error: (error: HttpErrorResponse) => {
            this.displayInfoTercero = false;
            this.config.handleError(error);
          }
        })
      }
    }
  }

  /**
 * Buscar información de un sistema externo integrado
 */
  searchClientExternSystem = () => {
    /*Import Clients of SIIGO*/
    if (!!localStorage.getItem('tokenSIIGO')) {
      let tokenSIIGO = JSON.parse(localStorage.getItem('tokenSIIGO') ?? "");
      this.integrationSupplier.getClientSiigo(this.token.token, tokenSIIGO, this.formVenta.controls.identificacion.value ?? "")
        .subscribe({
          next: (response) => {
            this.infoTercero = response as Array<any>;
            if (this.infoTercero.results.length > 0) {
              // filtrar la información del tercero que este activa en el campo sucursal
              this.infoTercero.results = this.infoTercero.results.filter((row: any) => { return row.active ?? false });
              this.displayInfoTercero = true;
            }
          },
          error: (error: HttpErrorResponse) => { this.config.handleError(error); }
        });
    }
  }



  //funcion para enviar la informaciòn del comprador
  setCliente() {

    let send: boolean = true;
    this.msgVenta = '';
    // encaso de no ser empresa
    if (this.formVenta.value.tipo?.idTipoIdentificacion != 3)
      this.formVenta.controls.razonSocial.setValue('NA');
    // si es impresion no se debe personalizar puede enviarse directo
    if (this.optNotificacion == 3 && !this.formVenta.valid) {
      this.formVenta.controls.tipo.setValue(this.listIdentificationType[0]);
      this.formVenta.controls.identificacion.setValue('222222222' as any);
      this.formVenta.controls.nombres.setValue('Consumidor final')
      this.formVenta.controls.correo.setValue('consumidor@final.com.co')
      this.formVenta.controls.telefono.setValue('');
      this.formVenta.controls.razonSocial.setValue('NA');
    }

    if (this.formVenta.valid) {
      // set client information
      let idCity: any = this.formVenta.controls.ciudad.value ?? '{}';
      const data = {
        "idCliente": this.selectedClient?.idCliente ?? -1,
        "idTipoIdentificacion": this.formVenta.controls.tipo.value?.idTipoIdentificacion ?? 1,
        "digito": this.digito,
        "identificacion": this.formVenta.controls.identificacion.value,
        "razonSocial": this.formVenta.controls.razonSocial.value ?? '',
        "nombres": this.formVenta.controls.nombres.value,
        "direccion": this.formVenta.controls.direccion.value ?? '',
        "telefono": this.formVenta.controls.telefono.value ?? '',
        "email": this.formVenta.controls.correo.value,
        "idCiudad": !idCity.idCiudad ? null : idCity.idCiudad,
      }
      // validar las opciones
      // validar el tipo de notificacion
      switch (this.optNotificacion) {
        case 1:
          // correo electónico
          if (data.email == "") {
            this.message.add({ severity: 'error', summary: 'Error', detail: 'Favor relacione el email para enviar la información' });
            send = false;
          }
          break;
        case 2:
          // whatsapp
          if (data.telefono == "") {
            this.message.add({ severity: 'error', summary: 'Error', detail: 'Favor relacione el numero de celular, no olvides añadir el indicativo del pais' });
            send = false;
          }
          break;
        case 4:
          // factura electronica
          if (data.email == "") {
            this.message.add({ severity: 'error', summary: 'Error', detail: 'Favor relacione el email para enviar la información' });
            send = false;
          }
          break;
      }

      if (send)
        this.venta.setVentaCliente(this.token.token, data, this.idVenta, this.optNotificacion).subscribe({
          next: (response) => {
            // formalizar el envío de información

            if (this.optNotificacion == 1) {
              // correo electónico
              this.venta.sendNotificacion(this.token.token, data, this.idVenta).subscribe((resp) => {
                if (Boolean(resp.toString()))
                  this.msgVenta = "<div class='p-1 p-message p-message-success'> Se ha realizado la notificación al usuario</div>"
                else
                  this.msgVenta = "<div class='p-1 p-message p-message-error'> Algo ocurrio mal, favor intente nuevamente</div>"
              });
            }
            else if (this.optNotificacion == 2) {
              // whatsapp
              let url = this.config.urlHome + "venta/recibo/" + this.idVenta.toString() + "/" + ((this.selectedStore.processTypeFe ?? 3) == 1 ? 3 : this.infoParametrizacion.idComprobante);
              let message = "Hola " + data.nombres + ", a continuación relaciono tu *comprobante de pago*; haga clic sobre este enlace: " + this.config.urlHome + "Recibo/" + this.idVenta + "/" + ((this.selectedStore.processTypeFe ?? 3) == 1 ? 3 : this.infoParametrizacion.idComprobante) + " - lo invitamos a seguir comprando."
              window.open("https://wa.me/+57" + data.telefono + "?text=" + message, "_blank");
            }
            else if (this.optNotificacion == 3) {
              // impresion
              let urlRecibo = this.config.urlHome + "venta/recibo/" + this.idVenta.toString() + "/" + ((this.selectedStore.processTypeFe ?? 3) == 1 ? 3 : this.infoParametrizacion.idComprobante);
              window.open(urlRecibo + "?print=YES", "_blank");
            }
            else if (this.optNotificacion == 4) {
              // proceso de registro de factura electrónica
              this.venta.setInsertFE(this.token.token, { idVenta: this.idVenta },
                this.selectedStore.processTypeFe ?? 3).subscribe({
                  next: (response) => {
                    // se procede con el envío de JSON a Sistema integrador
                    if (response as number > 0) {
                      if (this.infoParametrizacion.integrationSystem == 'SIIGO')
                        this.setFacturaElectronicaSIIGO(this.idVenta);
                    }
                  },
                  error: (error: HttpErrorResponse) => { this.config.handleError(error); }
                })
            }

            this.msgVenta = "<div class='p-1 p-message p-message-success'> Se ha realizado la notificación al usuario</div>"
          }, error: (error: Response) => {
            this.msgVenta = "<div class='p-1 p-message p-message-error'> Se ha presentado un error en la notificación, favor valide la información ingresada</div>"
          }
        });
    }
    else
      this.message.add({ severity: 'error', summary: 'Error', detail: 'Favor relacione y valide la información en los campos resaltados' });
  }

  setFacturaElectronicaSIIGO = (idVenta: number) => {
    this.load = true;
    /// getInformationHeader
    this.venta.getHeaderIntegration(this.token.token, idVenta).subscribe({
      next: (response: any) => {
        let infoHeader = response as any;
        this.venta.getDetailHeaderIntegration(this.token.token, idVenta).subscribe({
          next: (response1: any) => {
            // add fields 
            let infoDetail = response1 as Array<any>;
            let totalSales = 0;
            console.log(infoDetail);
            infoDetail.map(row => {
              row.code = row.code.toString();
              row.taxes = (row.idTaxesExternSystem ?? '') != '' ?
                (row.idTaxesExternSystem ?? '').split(',').map((item: any) => {
                  return { id: item }
                }) : [];
              row.price = Number(row.price).toFixed(3);
              row.warehouse = !row.warehouse ? null : row.warehouse;
              row.discount = Number(row.discount.toFixed(2));
              totalSales = row.subtotal + row.tax;
              delete row.idTaxesExternSystem;
              delete row.subtotal;
              delete row.tax;
            });

            this.venta.getDetailPayments(this.token.token, idVenta).subscribe({
              next: (response2: any) => {

                let payments: any = response2 as Array<any>;

                // revisar si se tiene impuestos para descontar
                let valorImpuesto = 0;
                if (payments[0].ventaImpuestos.length > 0) {
                  valorImpuesto = payments[0].ventaImpuestos.filter((row: any) => { return row.operation == '-' })
                    .reduce((n: number, row: any) => n + row.valor, 0);
                }



                let paymentsFE = payments[0].ventaPagos.map((row: any) => {
                  return {
                    id: row.idVentaMetodoPagoNavigation?.metodoPagoProveedors[0]?.paymentsIdFe,
                    value: row.valor,
                    // plazo de pago si el metodo de pago lo exije
                    due_date: row.idVentaMetodoPagoNavigation?.metodoPagoProveedors[0]?.registerPaymentTerm ?
                      this.config.formatDateUnique(this.config.addDaysDate(response.date, (payments[0].idClienteNavigation?.carteras[0]?.plazodePago) ?? 1))
                      : this.config.formatDateUnique(response.date),
                  }
                });
                // dicount taxes
                //console.log(paymentsFE[0].value, Number(valorImpuesto.toFixed(2)), paymentsFE[0].value -  Number(valorImpuesto.toFixed(2)));
                paymentsFE[0].value = (paymentsFE[0].value - valorImpuesto).toFixed(2)


                this.load = false;
                //b solo se aceptan máximo dos campos
                let name = response.name.trim().split(' ');
                switch (name.length) {
                  case 3:
                    name.slice(2, 1);
                    break;
                  case 4:
                    name.slice(2, 1);
                    name.slice(name.length - 1, 1)
                    break;
                }
                //dejar en un array
                // razon social: si es compañia debe ser maximo un registro de 100 caracteres
                // otro: el nombre debe quedar en dos partes
                let nameCompany: Array<String> = [];
                if (response.codProveedorDian1 == '31') {
                  nameCompany = response.name.trim().substring(0, 99).split("|")
                } else {
                  // Conocer el numero de pálabras para otros tipos de documento
                  let arrayWords: Array<string> = infoHeader.name.trim().split(' ');
                  switch (arrayWords.length) {
                    case 3:
                      nameCompany.push(arrayWords[0] + " " + arrayWords[1]);
                      nameCompany.push(arrayWords[2])
                      break;
                    case 4:
                      nameCompany.push(arrayWords[0] + " " + arrayWords[1]);
                      nameCompany.push(arrayWords[2] + " " + arrayWords[3])
                      break;
                    default:
                      nameCompany.push(arrayWords[0]);
                      nameCompany.push(arrayWords[1]);
                      break;
                  }
                }

                // obteniendo los datos del último año y mes para saber cuando fue creado el cliente
                /* const currentDate = new Date();
                const lastDigitOfYear = currentDate.getFullYear() % 10;
                const currentMonth = currentDate.getMonth() + 1; */
                let ocCustom = {};
                // saber si viene personalizada la orden de compra
                if ((infoHeader.numberOc ?? "") != "") {
                  ocCustom =
                  {
                    "purchase_order": {
                      "prefix": infoHeader.prefijoOc ?? null,
                      "number": infoHeader.numberOc ?? null
                    }
                  }
                }

                const data: any = {
                  "document": {
                    "id": response.documentId
                  },
                  "date": this.config.formatDateUnique(response.date),
                  "customer": {
                    "person_type": response.personType,
                    "id_type": response.codProveedorDian1,
                    "identification": response.identificacion.toString(),
                    //"branch_office": `${lastDigitOfYear}${currentMonth.toString().padStart(2, '0')}`,
                    "branch_office": response.branchOffice,
                    "name": nameCompany,
                    "address": {
                      "address": response.address,
                      "city": {
                        "country_code": response.countryCode,
                        "state_code": response.stateCode,
                        "city_code": response.cityCode
                      },
                      "postal_code": ""
                    },
                    "phones": [
                      {
                        "indicative": response.indicative,
                        "number": response.number,
                        "extension": ""
                      }
                    ],
                    "contacts": [
                      {
                        "first_name": response.nameContact.split(' ')[0],
                        "last_name": response.nameContact.split(' ')[1],
                        "email": response.email,
                        "phone": {
                          "indicative": response.indicative.trim(),
                          "number": response.number.toString(),
                          "extension": ""
                        }
                      }
                    ],
                  },
                  "seller": response.seller,
                  "retentions": (response.idTaxesStr ?? '') != '' ?
                    (response.idTaxesStr ?? '').split(',').map((taxes: any) => {
                      return { id: taxes }
                    }) : [],
                  "stamp": {
                    "send": !(this.infoParametrizacion.checkFe ?? true)
                  },
                  "mail": {
                    "send": !(this.infoParametrizacion.checkFe ?? true)
                  },
                  "observations": response.observations,
                  "items": infoDetail,
                  "payments": paymentsFE,
                  "additional_fields": ocCustom
                }

                console.log('JSON FE', data, 'Proceso de registro');
                // una vez se tiene el JSON es posible enviarlo
                this.integrationSupplier.setSaleSiigo(this.token.token, data, idVenta).subscribe({
                  next: (responseSIIGO) => { console.log('responseSIIGO', responseSIIGO) },
                  error: (error: HttpErrorResponse) => { this.config.handleError(error); }
                })
              },
              error: (error: HttpErrorResponse) => { this.config.handleError(error); this.load = false; }
            });
          },
          error: (error: HttpErrorResponse) => { this.config.handleError(error); this.load = false; }
        });
      },
      error: (error: HttpErrorResponse) => { this.config.handleError(error); this.load = false; }

    });

  }

  setTemporal = (idVenta: number) => {
    // proceso de registro de factura electrónica
    this.venta.setInsertFE(this.token.token, { IdVenta: idVenta },
      this.selectedStore.processTypeFe ?? 3).subscribe({
        next: (response) => {
          // se procede con el envío de JSON a Sistema integrador
          if (response as number > 0) {
            this.setFacturaElectronicaSIIGO(idVenta);
          }
        },
        error: (error: HttpErrorResponse) => { this.config.handleError(error); }
      })
  }


  getFaltante = (event: any, label: string) => {

    let valorTemp = 0;
    this.selectedMethod.forEach((row) => {
      if (row.label == label)
        valorTemp += event.value
      else
        valorTemp += row.valor
    });
    this.valorFaltante = (this.subtotal + this.impuesto) - (valorTemp + (label == 'recaudo' ? event.value : this.valorRecaudo));
  }

  getFaltanteEfectivo = () => {
    this.valorFaltante = (this.subtotal + this.impuesto) - (this.valorRecaudo);
  }

  getSaleECommerce = () => {
    if ((this.nroSalesECommerce ?? 0) > 0) {
      this.ecommerce.getSalesByID(this.token.token, this.nroSalesECommerce ?? 0).subscribe({
        next: (response) => {
          this.salesECommerce = response as Array<any>;
          if (this.salesECommerce.length == 0)
            this.message.add({ severity: 'error', detail: 'No existe venta bajo el numero relacionado' });
          else
            this.salesECommerce.map((row: any) => {
              this.totales.subtotal = this.totales.subtotal + row.subtotal;
              this.totales.taxes = this.totales.taxes + row.taxes;
              this.totales.shippingCost = this.totales.shippingCost + row.shippingCost;
            });

        },
        error: (error: HttpErrorResponse) => { this.message.add({ severity: 'error', detail: 'Error: ' + error }); }
      })
    } else {
      this.message.add({ severity: 'error', detail: 'Favor relacione el nro. de venta de la tienda virtual' });
    }

  }

  setDetailECommerce = () => {
    if (this.salesECommerce[0].shippingCost > 0) {
      let shippingValue = this.listProducts.filter((item: any) => { return this.infoParametrizacion.idProductoFlete == item.idProducto })[0];
      this.onSetSku(shippingValue, 1,
        (this.salesECommerce[0].shippingCost * ((shippingValue.impuesto / 100) + 1)) / 1,
        (this.salesECommerce[0].shippingCost * ((shippingValue.impuesto / 100) + 1)) / 1);
    }

    //detail
    this.salesECommerce[0].detail.map((item: any) => {
      let resultsSKU = this.listProducts.filter(prod => {
        return prod.idProducto == item.idProducto
      });

      this.onSetSku(resultsSKU[0], item.quantity,
        (item.subtotal + item.taxes) / item.quantity,
        (item.subtotal + item.taxes) / item.quantity);
    });


  }


  clear() {
    this.listBuy = [];
    this.selectedSales = 0;
    this.subtotal = 0;
    this.impuesto = 0;
    this.idVenta = 0;
    this.idComprobante = 0;
    this.formVenta.reset;
    this.citySelected = {};
  }

  volver = () => {
    this.router.navigate(['auth'])
  }

  /* sendNotify = () => {
    this.notify.setNotify(this.token.token).subscribe({
      next: (response) => { console.log(response) }
    })
  } */




  replaceCharacter = (str: string) => {
    return str.replace(/[']+/g, "-");
  }


  /* @HostListener("window:beforeUnload", [ "$event" ])
  beforeUnloadHander(event:any) {
    event.returnValue = `You have unsaved changes, leave anyway ? `;
  } */

  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    if (event.key == "F3")
      this.displayInfoClient = true;
  }

}
